import { Category } from '../interfaces';

export function matchPathToCategories(path: string, categoryTree: Category[]): Category[] {
    const categoryNames = path.split('/');
    let categoryList = categoryTree;

    return categoryNames.reduce((categories, slug) => {
        const category = categoryList.find(category => category.slug === slug);
        if (!category) {
            throw Error(`Could not resolve path segment "${slug}" to category selection`);
        }
        categories.push(category);
        categoryList = category.subCategories;
        return categories;
    }, []);
}

export function createPathFromCategory(category: Category) {
    return (category.parentPath ? category.parentPath + '/' : '') + category.slug;
}
